export const ExitIcon = ({ fill }) => {
  return (
    // <svg
    //   width="25"
    //   height="18"
    //   viewBox="0 0 49 36"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M4.5 0C1.96875 0 0 2.0625 0 4.5V31.5C0 34.0312 1.96875 36 4.5 36H16.875C17.4375 36 18 35.5312 18 34.875V34.125C18 33.5625 17.4375 33 16.875 33H4.5C3.65625 33 3 32.3438 3 31.5V4.5C3 3.75 3.65625 3 4.5 3H16.875C17.4375 3 18 2.53125 18 1.875V1.125C18 0.5625 17.4375 0 16.875 0H4.5ZM30.6562 1.875L29.9062 2.53125C29.5312 3 29.5312 3.65625 29.9062 4.125L42.2812 16.4062H16.125C15.4688 16.4062 15 16.9688 15 17.5312V18.4688C15 19.125 15.4688 19.5938 16.125 19.5938H42.2812L30 31.9688C29.5312 32.4375 29.5312 33.0938 30 33.5625L30.6562 34.2188C31.0312 34.6875 31.7812 34.6875 32.25 34.2188L47.625 18.8438C48.0938 18.375 48.0938 17.7188 47.625 17.25L32.25 1.875C31.7812 1.40625 31.0312 1.40625 30.6562 1.875Z"
    //     fill="#378FC9"
    //   />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M96 480h64C177.7 480 192 465.7 192 448S177.7 416 160 416H96c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h64C177.7 96 192 81.67 192 64S177.7 32 160 32H96C42.98 32 0 74.98 0 128v256C0 437 42.98 480 96 480zM504.8 238.5l-144.1-136c-6.975-6.578-17.2-8.375-26-4.594c-8.803 3.797-14.51 12.47-14.51 22.05l-.0918 72l-128-.001c-17.69 0-32.02 14.33-32.02 32v64c0 17.67 14.34 32 32.02 32l128 .001l.0918 71.1c0 9.578 5.707 18.25 14.51 22.05c8.803 3.781 19.03 1.984 26-4.594l144.1-136C514.4 264.4 514.4 247.6 504.8 238.5z"
      />
    </svg>
  );
};
